import React from 'react'
import classnames from 'classnames'

import BotHeadColored from 'src/Components/shared/Avatar/BotHeadColored'

import styles from './Warnings.module.scss'

const WarningLayout = ({
  icon: Icon,
  className,
  type,
  quizzical,
  children
}) => {
  return (
    <div className={classnames(styles.callout, className)}>
      {!!Icon && <Icon />}
      {!Icon && <BotHeadColored size='xs' quizzical={quizzical} type={type} />}
      {children}
    </div>
  )
}

WarningLayout.defaultProps = {
  quizzical: true
}

export default WarningLayout
